import React from "react";
import classes from "./bookingCard.module.css";
import { Close } from "@mui/icons-material";
import { CheckCircle } from "lucide-react";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  appointmentDate,
  appointmentTime,
  appointmentDetails,
}) => {
  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <div className={classes.modalHeader}>
          <h3>Confirm Booking Approval</h3>
          <Close
            fontSize="medium"
            className={classes.closeIcon}
            onClick={onClose}
          />
        </div>
        <div className={classes.modalBody}>
          <div className={classes.warningContainer}>
            <CheckCircle className={classes.confirmIcon} />
            <p className={classes.warningText}>
              Are you sure you want to confirm this booking? It will generate a
              payment link for the client.
            </p>
          </div>
          <div className={classes.appointmentDetails}>
            <p>
              <strong>
                Please be absolutely sure about your availability at:
              </strong>
            </p>
            <p className={classes.detailText}>Date: {appointmentDate}</p>
            <p className={classes.detailText}>Time: {appointmentTime}</p>
            <p className={classes.detailText}>
              Duration: {appointmentDetails.duration} hours
            </p>
            <p className={classes.detailText}>
              Details: {appointmentDetails.details}
            </p>
            <p className={classes.detailText}>
              Amount: ₹{appointmentDetails.amount}
            </p>
          </div>
        </div>
        <div className={classes.modalFooter}>
          <button className={classes.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <button className={classes.confirmButton} onClick={onConfirm}>
            Confirm Approval
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
